module.exports = __webpack_public_path__ + "static/media/icn-prix-negociables.f73cc741.png";